export default "__VITE_ASSET__DmS1RfQB__"